module.exports = __webpack_public_path__ + "img/info-gray.11a6f327.svg";